import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

const Signature = ({settings = {}}) => {
    return (
        <InputWrapper>
            <span className="signature">............</span>
            <span className={classNames({"required": settings.required})}>{settings.title}</span>
            {settings.description && <p>{settings.description}</p>}
        </InputWrapper>
    )
};

export default Signature;